import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";
import { FreelancerProfile } from "../../../../../models/FreelancerProfile";
import { FreelancerOnboardingStatus } from "../../../../../models/enums/FreelancerOnboardingStatus";

interface ActionButtonsSectionProps {
	isSubmitting: boolean;
	onSaveProgress: () => void;
	freelancerProfile: FreelancerProfile | null | undefined;
}

const ActionButtonsSection: React.FC<ActionButtonsSectionProps> = ({
	isSubmitting,
	onSaveProgress,
	freelancerProfile
}) => {
	const { t } = useTranslation();

	// The profile can momentarily be undefined while the upstream freelancer query refetches
	// (e.g. on a language change). Don't render the actions until it's available.
	if (!freelancerProfile) {
		return null;
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				gap: 3,
				mt: 10
			}}
		>
			<Button
				type="submit"
				variant="contained"
				color="secondary"
				disabled={isSubmitting}
				sx={{
					backgroundColor: zoullooColors.secondary.main,
					width: "45%",
					color: zoullooColors.secondary.contrastText,
					py: 1.5
				}}
			>
				{freelancerProfile.onboarding.currentStatus !==
				FreelancerOnboardingStatus.Accepted
					? t("freelancerOnboardingMyProfessionalInformation.buttons.personalInfo")
					: t("common.save")}
			</Button>
			{freelancerProfile.onboarding.currentStatus !==
				FreelancerOnboardingStatus.Accepted && (
				<Button
					variant="outlined"
					color="secondary"
					onClick={onSaveProgress}
					sx={{ width: "45%" }}
				>
					{t("freelancerOnboardingMyProfessionalInformation.buttons.back")}
				</Button>
			)}
		</Box>
	);
};

export default ActionButtonsSection;
